export default {
  'newIndex':'首页-H5',
  'register':'注册页面-H5',
  'login':'登录页面-H5',
  'tradeCompetition':'活动页面-SODI空投-H5',
  'listingTokenFlow': '创建交易对流程页面-H5',
  'verification': '官方验证通道页面-H5'
}



// WEBPACK FOOTER //
// ./src/utils/route_page_name.js